{
  "nl": {
    "materialGenerationPromptModal": {
      "buttons": {
        "generate": "Voorstel genereren"
      },
      "description": "Het ontwerp van het {material} is gebaseerd op jouw {sourceKind}-inhoud en is altijd bewerkbaar en uitbreidbaar.",
      "headers": {
        "fallbackTitle": "Materiaal maken met AI",
        "title": "{material} voor de {sourceKind} maken met AI"
      },
      "labels": {
        "language": "Taal",
        "prompt": "Vereisten"
      },
      "help": {
        "prompt": "Beschrijf hier aanvullend de doelgroep, lescontext en focus voor het {material}. Vermeld eventueel de leidende vraag, het leerdoel of bijzondere vereisten."
      },
      "placeholders": {
        "prompt": "Verdere vereisten toevoegen..."
      }
    }
  }
}
